var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurpleB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 485.6 548.9",
    style: {
      enableBackground: "new 0 0 485.6 548.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#812B8E;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M402.3,372.9c0,11.6-1.2,22.2-3.5,31.9c-15.4,64.6-79,89.9-154.1,89.9H83.3c-7.3,0-11.6-4.3-11.6-11.5v-403 c0-7.3,4.3-11.6,11.6-11.6h155.8c87,0,141.7,23.4,153.9,89.9c1.7,9.4,2.6,19.6,2.6,30.7c0,7.4-1.1,14.6-3.1,21.4 c-8.6,29.8-33.7,54.1-57,68c-3.6,1.8-3.6,4.3,0,6.1c28.9,17.3,55.9,37,64.2,68.1C401.4,359,402.3,365.7,402.3,372.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399.7,352.7H189.5V305h101.3v-52.1H189.5v-42.3h203c2-6.9,3.1-14,3.1-21.4c0-11.1-0.9-21.3-2.6-30.7H132.2 v246.4h266.5c2.3-9.7,3.5-20.3,3.5-31.9C402.3,365.7,401.4,359,399.7,352.7z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleB);
export default __webpack_public_path__ + "static/media/purple_b.86cf673932d1b8713f594bbddfc4c4f2.svg";
export { ForwardRef as ReactComponent };